module.exports = __webpack_public_path__ + "img/excel-logo.be1669c6.svg";